module.exports = __webpack_public_path__ + "img/sand-dune-decal-11.9a471391.png";